module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-4"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("Chapter Two")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic",
    staticStyle: {
      "font-size": "1.76em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("‘Y")]), _vm._v("ou’ll never catch them in that,’ Mia mumbled quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Will turned to look at her with inquisitive eyes. It was the first time she’d spoken since they’d left the fort, despite his valiant efforts to engage her in conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Well, you won’t,’ she said after a few seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I won’t be able to outrun them,’ Will corrected her. ‘I will be able to catch them.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mia fell silent again and looked around the dock. She knew some of the sailors judiciously avoiding her eye—she wasn’t going to get any help from them. And the shackles that restrained her wrists weren’t conducive to escape, either.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I hope you’re not thinking of running away, young lady,’ Thatcher said sternly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She smiled her sweetest smile. ‘Why would I want to do that?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Thatcher grunted.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I’m being treated so well.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Were the shackles really necessary?’ Will asked, turning back to look uneasily at the chains on her wrists.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Can’t be too careful, Greenacre. This little lady had evaded us for months.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Would have been longer...’ Mia muttered, looking pointedly at Will.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Not that she really regretted saving him. If she hadn’t jumped into the sea he would have been dead and she would have been free, but her conscience would never allow her to forget she had killed a man. And in her eyes allowing him to drown when she had the capability to save him would have been murder as sure as shooting him in the heart.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Shall we, my lady?’ Will asked, motioning to the ship.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They walked up the gangplank and on to the ship. She saw Will hesitate for just a second before he placed his foot on the wood of the deck, overcoming the memories of what happened the last time he was aboard a vessel like this.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The crew were all lined up along one side, waiting patiently for their orders. One man stepped forward and approached their little party.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Captain Little. Pleasure to have you aboard, Mr Greenacre.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The Captain was a lithe man of about fifty. His eyes flitted backwards and forwards all the time as if taking in every detail and his skin had the weather-beaten leathery look all sailors shared in the Caribbean.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Thank you for your hospitality, Captain.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘May I introduce my First Mate, Ed Redding.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A young man stepped forward and shook Will’s hand. He glanced at Mia and smiled sadly as if commiserating with her for getting caught.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘And this is Lieutenant Glass.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Another man stepped up and shook Will’s hand.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘A pleasure to serve with you, Mr Greenacre. It will be an honour to assist you in catching these pirates.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Lieutenant Glass is here at the Navy’s request. He will be representing their interests in our voyage.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I am here to give whatever help I can.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mia studied him. He looked rather dashing in his pristine white waistcoat and blue coat—each of the buttons shimmered in the sunlight and reflected the mid-afternoon rays. There was not a hair out of place in his ponytail and not a single scuffmark on his shoes. He was most likely a stickler for rules and routine.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She diverted her gaze back to Will and watched as he walked down the line of assembled men, greeting each in turn, asking their names and a little about their lives. He was good at getting people to like him; Mia could see that already. The crewmen were not used to a Commander who took an interest in them as people. In a few days they’d probably lay down their lives for him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘When do we sail?’ Will asked when he was back by the Captain’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘The tide is favourable for the next few hours. If we miss that, we shall have to wait until the morning.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mia willed them to wait until the morning. That way she might have a chance of escape. Once the ship was out to sea she had no chance.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘No time like the present,’ Will said with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Where shall I set a course for, sir?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Port Royal, Jamaica. I have some information to pick up there.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mia allowed herself a small, inconspicuous smile. Port Royal was a notorious haven for pirates even now with their new Governor, but it wasn’t where her brother would be hiding out. He’d always said that although you could lose yourself in the crowds in Port Royal and Tortuga, if someone really wanted to find you and had enough gold they would be able to buy information about your whereabouts.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘We will leave within the hour,’ the Captain assured him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘That’s my cue to leave,’ Thatcher said, clapping Will on the back, ‘Best of luck and, whatever you do, don’t let those pirates engage you in the open.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I’ll see you soon, old friend.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mia watched as Thatcher walked back to dry land and felt her hope of escape ebbing away.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Shall we make you more comfortable?’ His voice was low and close to her ear and sent shivers down her spine.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I can’t imagine that would be conducive to your plans,’ Mia replied.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I am sorry, you know,’ Will said. ‘I didn’t plan any of this.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Looking into his eyes, Mia nearly believed him. In fact, she wanted to believe him, but had to keep telling herself to stop being so naive. He was using her. He would extract whatever information he could from her, then deliver her back to the Governor to spend the rest of her days in chains.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Let me go,’ Mia said quietly so only Will would hear.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I’m sorry, that just isn’t possible.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I saved your life.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘And I’ll always be grateful for that.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘But your gratitude doesn’t extend to giving me my freedom.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Will sighed and turned so he was facing her directly. He placed his hands on her upper arms and looked squarely into her eyes. Mia shivered a little at the contact and the proximity of his body.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘When this is over I will argue your case, that I promise. I will do everything in my power to see you have your freedom back.’ His voice hardened. ‘But you have to understand, my priority is catching these pirates and I won’t let anything stand in my way.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mia swallowed hard, but held his gaze. He was a driven man. He reached over and took her hands in one of his, holding them still so he could unlock the shackles on her wrists. His hands were slightly rough against her softer skin, but his touch was gentle.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Shall I show you your quarters?’ Lieutenant Glass offered, breaking the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Thank you.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘We can put her in the brig on our way.’ He motioned towards Mia, a sneer on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Will turned slowly to face the Navy Officer. ‘The brig?’ he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘It’s a kind of prison cell on the ship, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I know what it is.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lieutenant Glass stood looking at Will with a perplexed expression. Neither man spoke for twenty seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘It’s very secure, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I don’t doubt the security of the cell.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I’m sorry, sir,’ Lieutenant Glass said eventually. ‘I don’t think I understand.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Miss Del Torres is helping us with our mission.’ Will spoke slowly. ‘She has very kindly agreed to impart her valuable knowledge so we may be successful in catching these scoundrels. I don’t think we should be locking our guest up in the brig, do you, Lieutenant?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Guest, sir?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Yes. Guest.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mia felt herself scoff. It wasn’t a ladylike noise, but she could see the Captain and the Naval Officer mirrored her disbelief.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Are you planning on escaping, Miss Del Torres?’ Will said, turning his attention on her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yes, yes, yes. Yes a thousand times.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘There you have it,’ Will said with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘But...’ Glass protested.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Yes?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘She’s the sister of a pirate.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘And I once was the neighbour of a man who beat his wife. Does that make me a violent lowlife?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Glass looked at him as if he’d grown two heads.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘But what if she tries to escape?’ he queried valiantly one more time.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Then we’ll have to catch her.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The Lieutenant was stunned into silence.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Lead on,’ Will commanded, taking Mia’s arm in his own. ‘Take us to our rooms.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mia allowed herself to be led forward and down into the bows of the ship. Men scurried backwards and forwards, getting everything ready for their voyage.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘This is your room, sir,’ Glass said, opening the door to a cramped but well-furnished cabin. It had a large four-poster bed that filled over half the floor space. Mia felt herself drawn to it and scolded herself immediately; she was there as a prisoner, not to lounge about on the bed of a man she barely knew.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Nice bed,’ Will said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mia realised she’d been staring and quickly averted her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘And for Miss Del Torres?’ Will asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ed Redding, the First Mate, came down the stairs behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Miss Del Torres can have my cabin,’ he said. ‘Come this way.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I don’t want to put you out,’ Mia said quickly. ‘I’ll be quite comfortable in the brig.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Redding turned to her with a laugh. ‘No one is comfortable in the brig, miss.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘But where will you sleep?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘There are spare bunks with the rest of the men. I’ll be fine down there for a couple of weeks.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘That’s very kind of you, Redding,’ Will said, ‘I appreciate it.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The First Mate led the way further into the ship and stopped outside a narrow wooden door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘It’s not much,’ he said, ‘but it’s comfy enough.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Thank you,’ Mia said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I’d better get back up on deck. We’ll be leaving in a few minutes.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Redding left and Lieutenant Glass reluctantly followed behind, leaving Will and Mia alone.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Will you be comfortable here?’ Will asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mia realised he was genuinely concerned. He might be her captor and willing to use her to find her brother, but he was considering her comfort at the same time. Things could be worse: she could be in the hands of Lieutenant Glass.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I will, thank you,’ Mia said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He turned as if to leave, then slowly spun round again to face her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Mia,’ he said slowly, ‘I meant what I said earlier.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked at him. The small frown line in between his eyebrows was back again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I might not agree with the Governor’s methods and I am sorry you’ve got caught up in this, but I have made an oath to bring your brother and his associates to justice and I need your help. I know you don’t want to be here, but if you help me I promise I will do everything I can to protect you when we get back to Barbados.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mia nodded slowly. She felt torn. She believed him, she believed that if she helped him he would try to protect her, but she also knew it would be in vain. She’d watched so many men and boys she’d known from childhood hang and she knew if she set foot on Barbados again as a prisoner she could well be heading for the noose.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I understand you are going to feel loyalty to your brother, but he has killed hundreds of innocent men and women. I can’t let that continue.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He moved in closer so there was only a sliver of air between their bodies. Mia looked up at him and tried to concentrate—she found it so distracting when he was this close. They stood for a moment just looking at each other, trying to figure out what their next move was. She had to consciously stop herself from reaching up and running her fingers through his golden hair, pulling his head down so his lips met hers.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Shall we return to the deck?’ Will said suddenly, stepping away.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mia felt as though she had been jolted awake from a trance. She nodded and docilely followed him up the wooden stairs and back into the humid air.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-3"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623409d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterTwo.vue
// module id = 84
// module chunks = 0